/**
 * @description Mensajes de las operaciones sobre recursos de archivo (Firebase Storage y
 * documentos servidos por el backend). Una constante por operación; el `%s` recibe el nombre
 * del recurso ('el recurso', 'el documento', 'la factura', ...) via `Fmt.string`.
 */
export enum ResourceMessages {
  /** Fallo leyendo el recurso, obteniendo su URL de descarga o previsualizándolo */
  ERROR_LOAD = 'Ocurrió un error al cargar %s',
  /** Fallo subiendo el recurso a Storage */
  ERROR_UPLOAD = 'Ocurrió un error al subir %s',
  /** Fallo descargando el archivo ya disponible */
  ERROR_DOWNLOAD = 'Ocurrió un error al descargar %s',
  /** Subida completada correctamente */
  SUCCESS_UPLOAD = 'Se cargaron %s exitosamente',
}
